import { ITransshipment, TTransshipmentStepId } from '../../types';
import { TDocumentCategory } from '~services/types';

export const representativeWelcome = {
  path: 'bem-vindo/representante',
  next,
};
export const spouseWelcome = {
  path: 'bem-vindo/conjuge',
  next,
};

function next(trans: ITransshipment): TTransshipmentStepId {
  switch (trans.data.status) {
    case 'finalize-personal-data':
      return trans.type === 'representative'
        ? 'representative-finalize-personal-data-page'
        : 'spouse-finalize-personal-data-page';

    case 'marital-status':
      return 'marital-status-page';

    case 'spouse-register':
      return 'spouse-register-page';

    case 'documents-collect':
      return documentsCollectNext(trans);

    case 'retake-documents':
      return retakeDocumentsNext(trans);

    case 'account-password':
      return 'account-password-page';

    default:
      return 'success-page';
  }
}

function documentsCollectNext(trans: ITransshipment): TTransshipmentStepId {
  if (!trans.data.documents || trans.data.documents.length === 0)
    return 'identity-document-type-page';

  const identityTypeDocs = trans.data.documents.filter(
    (doc) => doc.category === 'identity'
  );

  if (
    identityTypeDocs.length === 1 &&
    (identityTypeDocs[0].type === 'rg-front' ||
      identityTypeDocs[0].type === 'rg-back')
  )
    return 'identity-document-type-page';

  if (!trans.data.documents.some((doc) => doc.category === 'selfie'))
    return 'selfie-page';

  return trans.type === 'representative'
    ? 'documents-success-page'
    : 'success-page';
}

type TDocumentToFill = {
  category: TDocumentCategory;
  step: TTransshipmentStepId;
};

const documentSteps: TDocumentToFill[] = [
  { category: 'identity', step: 'identity-document-type-page' },
  { category: 'selfie', step: 'selfie-page' },
];

function retakeDocumentsNext(trans: ITransshipment): TTransshipmentStepId {
  if (!trans.data.documents || trans.data.documents.length === 0)
    return 'identity-document-type-page';

  for (const step of documentSteps) {
    if (
      trans.data.documents.some(
        (doc) => doc.category === step.category && doc.status === 'invalid'
      )
    )
      return step.step;
  }

  return trans.type === 'representative'
    ? 'documents-success-page'
    : 'success-page';
}
